import React, { useState, useEffect } from 'react';

const LoadingIndicator = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        // Reset to empty if it reaches 5 dots
        if (prevDots.length >= 4) return '.';
        // Append a dot otherwise
        return prevDots + '.';
      });
    }, 1000); // Increment every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return <div>Loading {dots}</div>;
};

export default LoadingIndicator;